<template>
    <el-select v-if="field.type === 'BOOLEAN'" :value="cachedValue" @input="onValueInput"
               :clearable="field.nullable">
        <el-option :value="true" label="是"></el-option>
        <el-option :value="false" label="否"></el-option>
    </el-select>
    <date-picker v-else-if="field.type === 'DATE'" :value="cachedValue" @input="onValueInput"></date-picker>
    <date-picker v-else-if="field.type === 'DATETIME'" :value="cachedValue" @input="onValueInput"
                 type="datetime"></date-picker>
    <time-picker v-else-if="field.type === 'TIME'" :value="cachedValue" @input="onValueInput"></time-picker>
    <el-input v-else-if="field.type === 'KEYWORD'&&!field.multiple&&!field.dictName" :value="cachedValue"
              @input="onValueInput"></el-input>
    <el-select v-else-if="field.type === 'KEYWORD'&&field.multiple&&!field.dictName" :value="cachedValue"
               @input="onValueInput" filterable allow-create multiple clearable default-first-option></el-select>
    <el-cascader v-else-if="field.type === 'KEYWORD'&&field.dictName" :value="cachedValue" @input="onValueInput"
                 :props="{lazy:true,lazyLoad:loadDict,label:'name',emitPath: false,multiple:field.multiple,checkStrictly:true}"
                 :clearable="field.nullable"></el-cascader>
    <el-input v-else-if="field.type === 'TEXT'" type="textarea" :value="cachedValue"
              @input="onValueInput"></el-input>
    <el-input v-else-if="['LONG','INTEGER','SHORT','DOUBLE','FLOAT'].indexOf(field.type)!==-1" type="number" :value="cachedValue"
              @input="onValueInput"></el-input>
</template>

<script>
    import dictService from '../../service/dict'
    function clone(value) {
        if(value === null||value===undefined){
            return value
        }
        const type = typeof value
        if(type === 'object'){
            return JSON.parse(JSON.stringify(value))
        }
        return value
    }
    export default {
        name: "NewsFieldInput",
        props: ['field', 'value'],
        data(){
            return {
                cachedValue: clone(this.value),
            }
        },
        watch:{
            value(newValue){
                this.cachedValue = clone(newValue)
            }
        },
        methods:{
            onValueInput(newValue){
                this.$emit('input', newValue)
            },
            processDictTree(nodes, parentPath){
                for(const node of nodes){
                    node.value = parentPath?(parentPath+'/'+node.name):node.name
                    if(node.children){
                        this.processDictTree(node.children, node.value)
                    }
                }
            },
            loadDict(node, resolve){
                if(node.root){
                    dictService.getDictTree(this.field.dictName).then(response => {
                        this.processDictTree(response.data, null)
                        resolve(response.data)
                    })
                }else{
                    resolve()
                }
            }
        }
    }
</script>

<style scoped>

</style>
